import { Info } from "react-feather";
import { useMediaQuery } from "react-responsive";
import { convertToBlocks } from "../helper";
import Input from "../components/input/Input";

const InfoList = ({
  title,
  Icon = Info,
  iconParams = {},
  content = [],
  singleColumn = false,
  showSegment = true,
  showHeader = true,
}) => {
  const smallScreen = useMediaQuery({ query: "(max-width: 1920px)" });

  const singleColumnContainerStyle = {
    padding: "20px",
    display: "flex",
    gap: "10px",
    flexDirection: "column",
  };

  const singleColumnColStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    width: "99%",
    margin: 0,
  };

  const containerStyle = {
    padding: "20px",
    display: "flex",
    gap: "10px",
    // alignItems: "center",
    justifyContent: smallScreen ? "flex-start" : "space-between",
  };

  const colStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    width: smallScreen ? "49%" : "24%",
    margin: 0,
  };

  // const rowStyle = {
  //   display: "flex",
  //   alignItems: "center",
  //   height: "40px",
  //   gap: "5px",
  // };

  // const contentStyle = { minWidth: "180px", margin: 0 };

  const rowStyle = {
    display: "flex",
    alignItems: "flex-start",
    gap: "5px",
    flexWrap: "wrap",
    margin: "5px 0px"
  };

  const contentStyle = {
    minWidth: "180px",
    margin: 0,
    wordBreak: "break-word",
    whiteSpace: "normal",
    flex: 1,
  };

  const labelStyle = {
    minWidth: "160px",
    textAlign: "start",
    margin: 0,
  };

  const separatorStyle = {
    margin: 0,
  };

  const columnList = convertToBlocks(content, smallScreen ? 2 : 4);

  const singleColumnList = convertToBlocks(content, 1);

  return (
    <div className={showSegment ? "ui segment" : ""}>
      {showHeader && (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <Icon {...iconParams} />
            <h3 style={separatorStyle}>{title}</h3>
          </div>
          <div className="ui divider"></div>
        </>
      )}
      {singleColumn ? (
        <div style={singleColumnContainerStyle}>
          {singleColumnList.map((column) => (
            <div style={singleColumnColStyle}>
              {column.map((row) => (
                <div style={rowStyle}>
                  <div style={labelStyle}>{row.title}</div>
                  <div style={separatorStyle}>:</div>
                  {row?.type === "number" || row?.type === "text"? (
                    <div className="ui input" style={{ flex: 1 }}>
                      <input
                        type={row.type}
                        value={row.value ?? ""}
                        onChange={(e) => {
                          row.onChange && row.onChange(e.target.value);
                        }}
                        placeholder={"Enter KM Value"}
                      />
                    </div>
                  ) : (
                    <h4 style={contentStyle}>{row.value}</h4>
                  )}
                  {/*<h4 style={contentStyle}>{row.value}</h4>*/}
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <div style={containerStyle}>
          {columnList.map((column) => (
            <div style={colStyle}>
              {column.map((row) => (
                <div style={rowStyle}>
                  <div style={labelStyle}>{row.title}</div>
                  <div style={separatorStyle}>:</div>
                  {row?.type === "number"  || row?.type === "text" ? (
                    <div className="ui input" style={{ flex: 1 }}>
                      <input
                        type={row.type}
                        value={row.value ?? ""}
                        onChange={(e) => {
                          row.onChange && row.onChange(e.target.value);
                        }}
                        placeholder={"Enter KM Value"}
                      />
                    </div>
                  ) : (
                    <h4 style={contentStyle}>{row.value}</h4>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default InfoList;
